/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Erp_Again_AInputs */



/**
* | output |
* | --- |
* | "Yes. Choose any dates and download them. Every bill belongs to exactly one day — the last day of its service — so back-to-back downloads never repeat a row. ..." |
*
* @param {Partner_Faq_Erp_Again_AInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_erp_again_a = /** @type {((inputs?: Partner_Faq_Erp_Again_AInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Erp_Again_AInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja. Wählen Sie beliebige Daten und laden Sie sie herunter. Jede Abrechnung gehört zu genau einem Tag — dem letzten Tag ihrer Leistung —, daher wiederholen aufeinanderfolgende Downloads keine Zeile. Jede Zeile hat eine feste ID: Dieselben Daten ergeben dieselben Zeilen, und eine Zeile, deren Betrag korrigiert wird, behält ihre ID, sodass Ihr ERP sie als Korrektur erkennt.")
	return /** @type {LocalizedString} */ ("Yes. Choose any dates and download them. Every bill belongs to exactly one day — the last day of its service — so back-to-back downloads never repeat a row. Every row has a fixed ID: the same dates give the same rows, and a row whose amount is corrected keeps its ID, so your ERP can recognise it as a correction.")
});